import Base from './condition-base'
import renderFields from './webview-script.pug'

export default class WebviewScript extends Base
  Object.defineProperty this, "label", get: -> @t(".label")

  renderFields: renderFields
